import { Box, useTheme } from "@mui/material"
import { ClientDashboard } from "./Components/ClientDashboard";
import { TalentDashboard } from "./Components/TalentDashboard";
import { useAppSelector } from "../../Redux/store";
import { KaziLayout } from "../../Shared Components/Kazi/Layouts/KaziLayout";

export const Dashboard = () => {
    /* ******************** Hooks ******************** */
        const userType = useAppSelector( state => state.Global.userType);
    /* ******************** Variables ******************** */
        const isClient = userType === 'client';
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziLayout>
            {
                isClient ? 
                <ClientDashboard />:
                <TalentDashboard />
            }
        </KaziLayout>
    )
}